module.exports = __webpack_public_path__ + "img/VIETCOMBANK.17072f88.svg";